export default __webpack_public_path__ + "static/media/sololearn.6a51a7a0.svg";